import { Amount } from '~/components/amount'
import { Avatar } from '~/components/avatar'
import { Box } from '~/components/layout'
import { Heading, Text } from '~/components/typography'
import { routes } from '~/config/routes'
import { PageBySlugQuery } from '~/graphql/page-by-slug'
import { colors } from '~/styles/colors'
import { FundraiserWrapper } from './style'

type Props = {
  slug: string
  fundraisers: PageBySlugQuery['pageBySlug']['fundraisers']
  fundraisersTitle: string
}

export const TabFundraisers = ({
  slug,
  fundraisers,
  fundraisersTitle,
}: Props) => {
  return (
    <div>
      <Heading level={4} marginBottom={24}>
        {fundraisersTitle}
      </Heading>

      <Box borderTop={colors.border}>
        {fundraisers.map(fundraiser => (
          <FundraiserWrapper
            key={fundraiser.id}
            href={routes.fundraisingPage.home(slug, fundraiser.id).as}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Avatar
              size={56}
              user={{ profilePictureUrl: fundraiser.profilePictureUrl }}
              marginRight={28}
            />
            <Text bold style={{ flex: 1 }}>
              {fundraiser.name}
            </Text>
            <Text>
              <strong>
                <Amount>{fundraiser.raised}</Amount>
              </strong>{' '}
              raised
            </Text>
          </FundraiserWrapper>
        ))}
      </Box>
    </div>
  )
}

export default TabFundraisers
